module.exports = __webpack_public_path__ + "static/banner_ouvidoria-6aeeddb9315afbff24463740d97d520e.png";